import React from 'react';
import { Content } from './shared';

const BcbsGymMembership = () => (
  <Content>
    Did you know that working out is considered preventative care?
    <ol>
      <li>Visit the Fitness Your Way website.</li>

      <li>Go to Locations.</li>

      <li>Choose a location and click Enroll to register.</li>
    </ol>
  </Content>
);

export default BcbsGymMembership;
